<template>
  <div
    class="flex flex-col w-full h-full bg-[#111a27] text-slate-200 rounded-[22px] shadow overflow-hidden border border-white/10"
  >
    <!-- 채팅 헤더 -->
    <div class="bg-[#142235] px-4 py-3 border-b border-white/10">
      <div class="flex items-center justify-between gap-3">
        <span class="font-black text-[#1ec8ff]">채팅방</span>
        <button
          @click="openChatRooms"
          class="rounded-full border border-[#1ec8ff]/40 px-3 py-1.5 text-xs font-black text-[#1ec8ff] hover:bg-[#1ec8ff] hover:text-[#111a27]"
        >
          채팅방 목록 가기
        </button>
      </div>
    </div>
    <!-- 메시지 영역 -->
    <div class="flex-1 overflow-y-auto lg:overflow-hidden p-4 space-y-4" ref="messageContainer">
      <div
        v-for="message in messages"
        :key="message.id"
        class="flex"
        :class="message.senderId === currentUser?._id ? 'justify-end' : 'justify-start'"
      >
        <div
          class="max-w-xs lg:max-w-md px-4 py-2 rounded-lg"
          :class="
            message.senderId === currentUser?._id
              ? 'bg-[#1ec8ff] text-[#111a27] text-right font-bold'
              : 'bg-white/5 text-slate-100 border border-white/10 text-left'
          "
        >
          <!-- 닉네임: 타인만 표시 (좌측, 작게, 배경 없음) -->
          <div
            v-if="message.senderId !== currentUser?._id"
            class="mb-1 text-left text-xs font-medium text-[#1ec8ff]"
            :class="{ 'cursor-pointer hover:text-[#7de3ff]': message.senderId }"
            @click="openProfilePopup(message.senderId)"
          >
            {{ message.senderName }}
          </div>
          <!-- 메시지 내용 -->
          <div
            class="text-sm"
            :class="message.senderId === currentUser?._id ? 'text-right' : 'text-left'"
          >
            {{ message.message }}
          </div>
        </div>
      </div>
    </div>
    <!-- 메시지 입력 영역 -->
    <div class="bg-[#142235] border-t border-white/10 p-3">
      <div v-if="currentUser" class="flex gap-2">
        <input
          v-model="sendMessage"
          @keyup.enter="addMessage"
          type="text"
          placeholder="메시지를 입력하세요..."
          class="flex-1 px-3 py-2 rounded-xl border bg-black/30 border-white/10 text-slate-100 placeholder-slate-400 focus:outline-none focus:ring focus:ring-[#1ec8ff]/30"
        />
        <button
          @click="addMessage"
          :disabled="sendMessage.length === 0"
          class="px-5 py-2 rounded-xl bg-[#1ec8ff] text-[#111a27] font-black hover:brightness-110 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          전송
        </button>
      </div>
      <div v-else class="text-center">
        <button
          @click="$router.push({ name: 'login' })"
          class="px-5 py-2 rounded-xl bg-[#1ec8ff] text-[#111a27] font-black hover:brightness-110"
        >
          로그인 후 채팅하기
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatView',
  data() {
    return {
      sendMessage: '',
    };
  },
  computed: {
    messages() {
      return this.$store.state.messages;
    },
    currentUser() {
      return this.$store.state.currentUser;
    },
  },
  mounted() {
    // 최근 메시지 25개 초기 로드
    const base = process.env.VUE_APP_API_URL || 'http://localhost:3000';
    fetch(`${base}/chat/messages?limit=25`)
      .then((r) => r.json())
      .then((data) => {
        const list = (data && data.messages) || [];
        this.$store.commit('setMessages', list);
        this.$nextTick(() => this.scrollToBottom());
      })
      .catch(() => {});
    // 소켓 연결 및 메시지 리스너 설정
    this.$store.commit('onMessage');
    // 스크롤을 맨 아래로 이동 (보조)
    this.$nextTick(() => {
      this.scrollToBottom();
    });
  },
  updated() {
    // 메시지가 추가될 때마다 스크롤을 맨 아래로 이동
    this.$nextTick(() => {
      this.scrollToBottom();
    });
  },
  methods: {
    openProfilePopup(userId) {
      if (!userId) return;
      const route = this.$router.resolve({ name: 'profile', query: { userId } });
      const profileUrl = new URL(route.href, window.location.origin).href;
      const width = 560;
      const height = 760;
      const left = Math.max(0, window.screenX + (window.outerWidth - width) / 2);
      const top = Math.max(0, window.screenY + (window.outerHeight - height) / 2);
      const popup = window.open(
        profileUrl,
        `atozProfile${userId}`,
        [
          'popup=yes',
          `width=${width}`,
          `height=${height}`,
          `left=${Math.round(left)}`,
          `top=${Math.round(top)}`,
          'resizable=yes',
          'scrollbars=yes',
          'noopener',
          'noreferrer',
        ].join(','),
      );
      if (popup) {
        popup.opener = null;
        popup.focus();
      }
    },
    openChatRooms() {
      const route = this.$router.resolve({ name: 'chatRooms' });
      const width = Math.max(1180, Math.floor(window.screen.availWidth * 0.98));
      const height = Math.max(820, Math.floor(window.screen.availHeight * 0.96));
      const left = Math.max(0, window.screen.availLeft || 0);
      const top = Math.max(0, window.screen.availTop || 0);
      const features = [
        'popup=yes',
        `width=${width}`,
        `height=${height}`,
        `left=${Math.round(left)}`,
        `top=${Math.round(top)}`,
        'resizable=yes',
        'scrollbars=yes',
        'noopener',
        'noreferrer',
      ].join(',');
      const popupUrl = new URL(route.href, window.location.origin).href;
      const popup = window.open(popupUrl, 'atozChatRooms', features);
      if (popup) {
        popup.opener = null;
        popup.focus();
      }
    },
    addMessage() {
      if (!this.sendMessage.trim()) return;
      this.$store.commit('sendMessage', this.sendMessage);
      this.sendMessage = '';
    },
    formatTime(timestamp) {
      const date = new Date(timestamp);
      const now = new Date();
      const diffInHours = (now - date) / (1000 * 60 * 60);
      if (diffInHours < 24) {
        return date.toLocaleTimeString('ko-KR', {
          hour: '2-digit',
          minute: '2-digit',
        });
      } else {
        return (
          date.toLocaleDateString('ko-KR', {
            month: '2-digit',
            day: '2-digit',
          }) +
          ' ' +
          date.toLocaleTimeString('ko-KR', {
            hour: '2-digit',
            minute: '2-digit',
          })
        );
      }
    },
    scrollToBottom() {
      if (this.$refs.messageContainer) {
        this.$refs.messageContainer.scrollTop = this.$refs.messageContainer.scrollHeight;
      }
    },
  },
};
</script>

<style scoped>
.overflow-y-auto::-webkit-scrollbar {
  width: 6px;
}
.overflow-y-auto::-webkit-scrollbar-track {
  background: #111a27;
}
.overflow-y-auto::-webkit-scrollbar-thumb {
  background: rgba(30, 200, 255, 0.58);
  border-radius: 999px;
}
.overflow-y-auto::-webkit-scrollbar-thumb:hover {
  background: rgba(30, 200, 255, 0.86);
}
</style>
